import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

// Global styles applied to the entire application
export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
    overflow-x: hidden;
  }

  body {
    font-family: ${theme.fonts.primary};
    line-height: 1.6;
    color: ${theme.colors.black};
    background: ${theme.colors.white};
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.primary};
    margin-bottom: 1rem;
    font-weight: 600;
    color: ${theme.colors.black};
  }

  a {
    color: ${theme.colors.black};
    text-decoration: none;
    transition: ${theme.transitions.default};

    &:hover {
      color: ${theme.colors.black};
    }
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
    font-family: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  html {
    scroll-padding-top: 80px; /* Account for fixed header */
  }

  ::selection {
    background: ${theme.colors.black};
    color: ${theme.colors.white};
  }

  section {
    padding: ${theme.spacing.xl} 0;
  }
`;
